/**
 * Navigation history singleton — exposes react-router v6's imperative navigate
 * to non-component code (sagas, services). The App component mounts a tiny
 * <NavigationBridge /> that sets the singleton via `useNavigate()`.
 */

type NavigateFn = (to: string) => void;

let navigator: NavigateFn | null = null;

export function setNavigator(fn: NavigateFn): void {
  navigator = fn;
}

export function navigate(to: string): void {
  if (!navigator) {
    // Fallback for the unlikely case the bridge hasn't mounted yet.
    window.location.href = to;
    return;
  }
  navigator(to);
}
